export enum eAuthorType {
  Admin = 'Admin',
  ClientCompany = 'ClientCompany',
  ClientUser = 'ClientUser',
  LenderCompany = 'LenderCompany',
  LenderUser = 'LenderUser',
  VendorUser = 'VendorUser',
  Vendor = 'Vendor',
}
